import { RedemptionTransactionOrderPayload } from "../../types/transaction";
import { api } from "../axios";

export const createRedemptionTransaction = (
  payload: RedemptionTransactionOrderPayload
) => {
  return api.post("mf-redemptions/", payload);
};

export const deleteRedemptionTransactionApi = ({
  id,
  investment_account_guid,
}: {
  investment_account_guid: string;
  id: number;
}) => {
  return api.delete(`mf-redemptions/${id}/`, {
    data: { investment_account_guid },
  });
};

export const updateRedemptionTransactionApi = ({
  id,
  ...payload
}: RedemptionTransactionOrderPayload & {
  id: number;
}) => {
  return api.put(`mf-redemptions/${id}/`, payload);
};
